<template>
  <div v-if="activefilters && activefilters.filters" class="mb-3">
    <div class="mb-3">
    <!--
      <span class="text-muted">{{$t('filters.active_filters')}}: </span>
      -->
      <b-button v-for="filter in activefilters.filters" :key="filter.value" v-on:click.prevent="changeFilter(filter.sem_action.sem_url_action)" variant="success" size="sm" class="mr-1 mb-1 filterbutton">
      <b v-if="filter.componentName == 'Budget_Total'">{{$t('scifund.labels.'+filter.componentName)}}: {{formatBudget(filter.valueLabel)}}</b>

      <b v-else-if="filter.componentName == 'Publication_Date' || filter.componentName == 'Deadlines'">{{$t('scifund.labels.'+filter.componentName)}}: {{formatDate(filter.valueLabel)}}</b>

      <b v-else-if="filter.componentName == 'Opening_Dates'">{{$t('scifund.labels.'+filter.componentName)}}: {{formatDate(filter.valueLabel)}}</b>

      <b v-else>{{$t('scifund.labels.'+filter.componentName)}}: {{filter.valueLabel | truncate(50, '...')}}</b>


      <v-icon name="x" class="icon"></v-icon></b-button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'activefilters',
  data () {
    return {
      selected: null
    }
  },
  methods: {
    changeFilter: function (action) {
      this.$router.push( action );
    },
    formatDate: function (v) {
      return v.replaceAll('T000000Z', '').replaceAll('T000000.000Z', '').replaceAll('T00:00:00Z', '').replaceAll('T00:00:00.000Z', '');
    },
    formatBudget: function (v) {
      return v.replaceAll(/(\d+)(0{6})\b/g, "$1M");
    }
  },
  components: {
  },
  filters: {
    truncate: function (text, length, suffix) {
      if( text && text.length > length )
        return text.substring(0, length) + suffix;
      else
        return text;
    }
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    activefilters () {
      if (this.$store.state.response &&
          this.$store.state.response.active_filters) {
        return this.$store.state.response.active_filters
      }
      return null;
    }
  }
}
</script>

<style scoped>
  .icon {
    width: 12px;
    color: #35495e;
    margin-left: 6px;
    margin-bottom: 2px;
  }
  .icon:hover {
    color: #fff;
  }
  .filterbutton:hover {
    background-color: #369A6E !important;
  }
</style>
